import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { businessInfo } from '../mockData';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show button after a short delay for smooth entrance
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const whatsappMessage = encodeURIComponent(
    "Hi! I'm interested in your automotive services and would like to know more about available services."
  );

  const whatsappLink = `https://wa.me/1${businessInfo.whatsapp}?text=${whatsappMessage}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-button ${isVisible ? 'visible' : ''}`}
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <MessageCircle size={24} />
      <span className="whatsapp-text">Chat with us</span>
    </a>
  );
};

export default WhatsAppButton;
